import { render, staticRenderFns } from "./PgaCombobox.vue?vue&type=template&id=7b221331&"
import script from "./PgaCombobox.vue?vue&type=script&lang=ts&"
export * from "./PgaCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b221331')) {
      api.createRecord('7b221331', component.options)
    } else {
      api.reload('7b221331', component.options)
    }
    module.hot.accept("./PgaCombobox.vue?vue&type=template&id=7b221331&", function () {
      api.rerender('7b221331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaCombobox.vue"
export default component.exports